<template>
    <div id="work-at-bohemia" class="perks--wrapper compact-padding container ">
        <div class="container-grid">
            <div class="perks__slider">
                <div class="gradient-box"></div>
                <img src="/static/img/landing_page/mobile/about_bis_mobile.png"
                     srcset="/static/img/landing_page/about_bis.jpg 1000w" class="responsive--img">
            </div>

            <div class="about--info">
                <h1 class="heading--lg text-left heading">WORK AT <br/> BOHEMIA</h1>


                <p class="paragraph perks__paragraph text-left">Bohemia Interactive, you say? Yep, that’s us!
                    Most
                    people probably know us as the developer of Arma and DayZ, but we’ve been working on more
                    original games, such as Ylands, Take On Mars, and several unannounced projects. We're
                    currently
                    a company of 350+ international professionals with offices in the Czech Republic,
                    the
                    Netherlands, and Thailand. Still, we embrace our roots as an independent 'garage' developer,
                    which manifests itself in the way we work, communicate, experiment, and - of course - have
                    fun.</p>

                <div class="button-wrapper">
                    <basic-button tag="a" to="https://www.bohemia.net/company/about" type="black-bordered"
                                  class="learn-button">
                        Learn More
                    </basic-button>
                </div>
            </div>
            <div class="isocahedron-wrapper">
                <img src="/static/img/landing_page/isocahedron/isocahedron.svg" class="isocahedron">
                <img src="/static/img/landing_page/isocahedron/Polygon.svg" class="polygon">
                <img src="/static/img/landing_page/isocahedron/Rectangle%2010.svg" class="rectangle">
                <img src="/static/img/landing_page/isocahedron/Triangle.svg" class="triangle">
                <div class="gradient-line line-transform"></div>
            </div>
        </div>


    </div>
</template>

<script>
  import BasicButton from "../BasicButton";



  export default {
    components: {  BasicButton },
    name: "About"
  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/main";

    .isocahedron-wrapper {
        position: absolute;
        right: -273px;
        bottom: -54px;
        @media (max-width: 1850px) {
            display: none;
        }
        .polygon {
            position: absolute;
            top: -36px;
            right: 165px;
        }
        .rectangle {
            position: absolute;
            top: -6px;
            right: 0px;
            transform: rotateZ(-14deg);
        }
        .triangle {
            position: absolute;
            bottom: -36px;
            right: 140px;
            transform: rotateZ(-14deg);
        }
        .isocahedron {
        }
        .gradient-line {
            position: absolute;
            bottom: 0;
            right: -70px;
            width: 166px;
            height: 4px;
            transform: rotateZ(-136deg);
            background-image: -webkit-gradient(linear, right top, left top, from(rgba(110, 58, 203, 0.9)), to(rgba(0, 181, 242, 0.9)));
            background-image: linear-gradient(270deg, rgba(110, 58, 203, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
            background-repeat: no-repeat;
            background-size: 100% 15px;
        }
        @-moz-keyframes spin {
            100% {
                -moz-transform: rotate(360deg);
            }
        }
        @-webkit-keyframes spin {
            100% {
                -webkit-transform: rotate(360deg);
            }
        }
        @keyframes spin {
            100% {
                -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
            }
        }
    }

    .container-grid {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        position: relative;
    }

    .responsive--img {
        width: 100%;
        max-width: 100%;
        height: auto;
    }

    .perks--wrapper {
        margin-top: 187px;
        margin-bottom: 5em;
        @media (max-width: $compact) {
            margin-top: 80px;
        }
    }

    .perks__slider {
        position: relative;
        width: 690px;
        max-width: 690px;
        z-index: 1;

        @media (max-width: $compact) {
            width: 100%;
        }

        @media (max-width: $compact) {
            width: 190px;
        }

        @media (max-width: $tablet) {
            width: 400px;
            max-width: 400px;
        }
        @media (max-width: 1200px) {
            width: 500px;
            max-width: 500px;
        }
    }

    .about--info {
        padding: 0;
        @media (min-width: $compact) {
            flex: 1;
            padding-left: 15px;
            padding-top: 0px;
        }
        @media (min-width: $tablet) {
            flex: 1;
            padding-left: 34px;
            padding-top: 94px;
        }
    }

    .heading {
        color: $text-strong;
        z-index: 4;
        position: relative;
        margin-bottom: $heading-margin-bottom;

        @media (max-width: $tablet) {
            margin-left: 0;
            margin-bottom: 15px;
            margin-top: 20px;
        }
    }

    .learn-button {
        margin-top: 89px;

        @media (max-width: $tablet) {
            margin-left: 0;
            margin-top: 10px;
        }
        @media (max-width: 1200px) {
            margin-top: 10px;

        }
    }

    .gradient-box {
        background-image: linear-gradient(to top, #6f3bcb 0%, #00b5f2 100%);
        width: 329px;
        height: 650px;
        position: absolute;
        z-index: -2;
        opacity: .9;
        bottom: 0;
        left: -58px;
        top: -58px;
        @media (max-width: 1200px) {
            width: 185px;
            height: 515px;
            left: -55px;
            top: -28px;
        }
        @media (max-width: $tablet) {
            width: 185px;
            height: 515px;
            left: -55px;
            top: -28px;
        }
        @media (max-width: $compact) {
            width: 40%;
            height: 90%;
            left: -20px;
            top: -25px;
            z-index: -1;

        }
    }

    .button-wrapper {
        @media (max-width: $compact) {
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/landingPageComponents/AboutUs.vue